import type { Fields as Campaign } from 'models/Campaign'
import React from 'react'
import Review from 'scenes/CampaignCenter/Builder/Steps/Shared/Review'
import AudienceContainer from 'scenes/CampaignCenter/Builder/Steps/Shared/Review/components/Audience'
import AudienceBreakoutModal from './components/Audience/components/AudienceBreakoutModal'

type Props = {
  campaign: Campaign
  setCurrentStep: (step: string) => void
}

const TimeshiftReview: React.FC<Props> = props => {
  const { campaign, setCurrentStep } = props
  return (
    <Review
      campaign={campaign}
      setCurrentStep={setCurrentStep}
      audience={
        <AudienceContainer
          campaign={campaign}
          locationIds={campaign.config_location_ids}
          categoryIds={campaign.config_location_category_ids}
          setCurrentStep={setCurrentStep}
          renderAudienceBreakoutModal={props => (
            <AudienceBreakoutModal {...props} campaignType={campaign.type} />
          )}
        />
      }
    />
  )
}

export default TimeshiftReview
